<template>
	<main class="main_container" style="background-color: transparent;flex-wrap: wrap;">

		<!-- <section class="container  pt-3" data-aos="fade-up" id="example-carousel">

			<h3 class="mt-4 font-weight-bold " style="color: #fff;">APPLICATION FIELD</h3>
			<div class="row">
				<div class="col">
					<a href="#" class="btn" style="padding: 0.15rem 4.5rem;background-color: #FCB42E;"></a>
				</div>
			</div>
		</section>
		<div class="container photo-group mt-4">
			
			<div class="photo-container" v-for="(item, index) in field" :key="index">
				<img class="default-img" :src="item.img" alt="默认图片1">
				<div class="photo-title">{{ item.title }}</div>
			</div>
		</div>
		<section class="container mt-4"  >
			<div class="row" data-aos="fade-up">
				<div class="col-md-4 content_padding" v-for="(item, index) in displayedSlides" :key="index">
					<div class="border-0">
						<img class="card-img-top" :src="item.img" alt="Card image cap">
						<div class="card-body" style="text-align: left;padding:0.5rem 0">
							<h6 class="card-title">{{ item.title }}</h6>
							<p class="card-text">
								{{ item.date }}
							</p>
							<p class="card-text">
								{{ item.described }}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="dots mt-4">
				<span v-for="(item, index) in slidesgroup" :key="index"
					:class="['dot', { active: currentPage === index + 1 }]" @click="currentPage = index + 1" > {{index+1}}</span>
			</div>
            <div style="height: 30px;"></div>
		</section> -->
		<section>
			<div class="align-content-center m-4">
				<div class="page_title" style="display: flex;justify-content: center;">
					<div class="page_title" style="display: flex;justify-content: center;">
						<div>
							<h3 class="page_title" style="display: inline-block;
							height: 4.1rem;
							border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Vlog </h3>
						</div>
					</div>
				</div>
			</div>
			<div style="display: flex; width: 100%;justify-content:right;padding-right: 13%;">
				<SearchInput v-model="inputValue" style="width: 345px;" @keyEnter="searchData" />
			</div>
		</section>
		<section>
			<div style="width: 100%;margin: 0 auto;">
				<table
					style="width: 100%;background-color: #1D1D1B;margin: 0 auto;min-height: 800px;border-top: 1px solid #424242;">
					<tr>
						<td class="col-md-1-1"
							style="vertical-align: top; padding: 0;background-color: transparent;border-right: 1px solid #424242;">
							<section style="background-color: transparent;">
								<table style="width: 100%;">

									<tr>
										<td>
											<div class="tree-box" style="width: 100%;min-width: 200px;">
												<div class="tree-content" style="margin-top: 5px;overflow: hidden;">
													<el-tree ref="treeleft" :data="treeData" node-key="id" :indent="0"
														class="tree-line"
														:row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
														:default-expand-all="true" :highlight-current="false"
														:expand-on-click-node="false" @node-click="handleNodeClick">
														<span slot-scope="{ data }" class="custom-tree-node">
															<template>
																<div class="node_div">
																	<span class="name-box">
																		{{ data.name }}<span v-if="data.itemNum>0"
																			style="color: #F3AD2C;">({{data.itemNum}})</span>
																	</span>
																</div>
															</template>
														</span>
													</el-tree>
												</div>
											</div>
										</td>
									</tr>
								</table>
							</section>
						</td>
						<td class="container col-md-9-1" style="vertical-align: top;padding: 0;">
							<div style="background-color: transparent;min-height: 300px;">
								<section class="text-white pt-5 pb-5 pb-2" style="margin-left: 12%;margin-right: 15%;">
									<!-- <div class="row" v-for="(item, index) in displayedSlides" :key="index" -->
									<div class="row" v-for="item in paginatedData" :key="item.id"
										style="border-bottom: 1px solid #F1F1F1;">
										<div class="col-lg-3 pr-2 pt-2">
											<div class="overlay border-0 pb-2">
												<img class="card-img" v-if="item.isImage" :src="item.url"
													alt="Card image" style="max-height: 15rem;"
													@click="navigateTo(item.id)" loading="lazy" >
												<video :src="item.url" v-if="item.isVideo" style="max-height: 100px;"
													autoplay loop @click="toggleFullscreen(item.url)"
													ref="videoPlayer" preload="none" controls></video>
											</div>
										</div>
										<div class="col-lg-9 " style="display: flex;align-items: center;">
											<div class=" overlay border-0 text-left pb-2 px-3" style="flex: 1;"
												@click="navigateTo(item.id)">
												<h5 class="card-title mb-4">{{ item.title }}</h5>
												<p class="card-text text-muted mb-4">
													{{ item.summary }}
												</p>
												<div>
													<span class="card-text text-muted">
														{{ item.date }}
													</span>
												</div>
											</div>
											<div style=" width: 180px;">
												<button class="btn custom-btn-primary "
													@click="navigateTo(item.id)">Read More</button>
												<!-- @click="showContent(item.id)">Read More</button> -->
											</div>
										</div>
									</div>
									<div style="width: 100%;text-align: center;margin-top: 28px;margin-bottom: 50px;">
										<el-pagination background layout="prev, pager, next" :hide-on-single-page="true"
											:total="totalData" :page-size="pageSize"
											@current-change="handleCurrentChange" :current-page="currentPage">
										</el-pagination>
									</div>
									<!-- 分页点 -->
									<!-- <div class="dots mt-3" v-if="slidesgroup.length>0">
										<span v-for="(item, index) in slidesgroup" :key="index"
											:class="['dot', { active: currentPage === index + 1 }]"
											@click="currentPage = index + 1"></span>
									</div> -->

									<!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" style="background-color: black;" :show-header="false" >
										<el-form  style="background-color: black;" class="custom-content">
											<div v-html="currentContent"></div>
										</el-form>
									</el-dialog> -->
									<div v-if="dialogVisible" class="popup"
										style="width: 75%;height: 92%;max-width: 1000px;">
										<div
											style="height: 30px;text-align: right; background-color: #262626;padding-top: 5px;">
											<img src="/assets/img/Main/popMin.png" alt="" @click="dialogVisible = false"
												style="margin-right: 20px;">
											<img src="/assets/img/Main/popMax.png" alt="" @click="dialogVisible = false"
												style="margin-right: 20px;">
											<img src="/assets/img/Main/popExit.png" alt=""
												@click="dialogVisible = false" style="margin-right: 20px;">

										</div>
										<div style="overflow: auto;max-height: 845px;">
											<div v-html="currentContent"
												style="text-align: left;padding-left: 10px;padding-right: 10px; "></div>
										</div>


									</div>

									<div v-if="isFullscreen" class="popup" style="max-width: 1130px;max-height: 700px;">
										<div
											style="height: 30px;text-align: right; background-color: #262626;padding-top: 5px;">
											<img src="/assets/img/Main/popMin.png" alt="" @click="isFullscreen = false"
												style="margin-right: 20px;">
											<img src="/assets/img/Main/popMax.png" alt="" @click="isFullscreen = false"
												style="margin-right: 20px;">
											<img src="/assets/img/Main/popExit.png" alt="" @click="isFullscreen = false"
												style="margin-right: 20px;">

										</div>
										<div style=" width: 1100px;height: 630px;overflow: auto;">
											<video style="max-height: 100%;max-width: 100%;" autoplay loop controls>
												<source :src="currentVideo" type="video/mp4">
											</video>
										</div>
									</div>
									<!-- 弹窗 -->
									<div v-if="showModal" class="modal-overlay" @click="showModal = false">
										<div class="draggable-modal" @click.stop
											:style="{ top: modalTop + 'px', left: modalLeft + 'px' }"
											@mousedown="startDrag">
											<div class="modal-header">
												<h3
													style="display: inline-block;color: rgb(252, 180, 46);padding-top: 5px;width: calc(100% - 20px);text-align: center">
													{{popTitle}} </h3>
												<button @click="closeShowModal" class="close-btn">×</button>
											</div>
											<div class="modal-content">
												<div style="text-align: left;padding-left: 0.8rem;padding-top: 10px;">
													<h5>{{popSum}}</h5>
												</div>
												<div
													style="text-align: left;padding-left: 1.2rem;padding-top: 10px;font-size: 12px;">
													{{popDate}}</div>
												<div v-html="currentContent"
													style="text-align: left;padding-left: 10px;padding-right: 10px;padding-top: 20px;">
												</div>
											</div>
										</div>
									</div>
								</section>
							</div>
						</td>
					</tr>
				</table>
			</div>
		</section>
	</main>
</template>

<script>
	import SearchInput from '@/components/common/SearchInput.vue';
	import { getVlogData, getVlogTypeNum, getVlogNoContent } from "@/api/rbac/vlog";
	export default {
		components: {
			SearchInput,
		},
		data() {
			return {
				inputValue: '',
				field: [
					{ img: "/assets/img/Main/OffRoad.png", title: "Off Road" },
					{ img: "/assets/img/Main/Emergency.png", title: "Emergency & Warning" },
					{ img: "/assets/img/Main/Truck.png", title: "Truck" },
					{ img: "/assets/img/Main/Agricultural.png", title: 'Agricultural' },
					{ img: "/assets/img/Main/Marine.png", title: "Marine" },
					{ img: "/assets/img/Main/Mining.png", title: "Mining" },
					{ img: "/assets/img/Main/FireTruck.png", title: "Fire Truck" },

				],
				slides: [
					// { img: "/assets/img/Main/video1.png", title: "Shaping the Future of Driving", date: '2024/11/20', described: 'From the humble halogen lamp to state-of-the-art laser and LED systems, the evolution of headlight technology tells the story of automotive progress. These advancements not only enhance visibility but also contribute to sustainability through improved energy efficiency and reduced emissions, while meeting the aesthetic demands of modern consumers.' },
					// { img: "/assets/img/Main/video2.png", title: "Smart Headlights Revolutionize Night Driving", date: '2024-12-16', described: 'The latest advancements in adaptive lighting technology, including laser headlights and automatic beam adjustment, are setting new standards for night driving safety. These systems not only improve visibility but also dynamically respond to road conditions and other vehicles, ensuring a safer and more comfortable journey for all road users.' },
					// { img: "/assets/img/Main/image1.png", title: "The Aesthetic Evolution of Automotive Lighting", date: '2024-12-16', described: 'Automotive lighting has transcended its utilitarian roots, becoming a key component of vehicle design. With the adoption of LED and OLED technologies, headlights now offer unparalleled customization, energy efficiency, and visual appeal. They define a car’s identity while delivering superior performance, aligning form with function in perfect harmony.' },
					// { img: "/assets/img/Main/image1.png", title: "Lighting the Way to Safer Roads", date: '2024-12-16', described: 'Cutting-edge innovations like matrix beams, infrared night vision, and adaptive high-beam assist are transforming nighttime driving. These advanced systems enhance visibility, minimize glare for oncoming drivers, and actively detect pedestrians and obstacles, making roads safer for everyone.' },
					// { img: "/assets/img/Main/image1.png", title: "The Rise of Intelligent Headlights", date: '2024-12-16', described: 'Headlight technology is rapidly evolving from basic illumination to intelligent systems that support connected and autonomous driving. Features such as real-time traffic detection, weather adaptation, and vehicle-to-vehicle communication are becoming integral, ensuring seamless integration with the broader smart vehicle ecosystem.' },
					// { img: "/assets/img/Main/video2.png", title: "The Tech Behind the Glow", date: '2024-12-16', described: 'Today’s automotive lighting systems are a fusion of technology and artistry. Dynamic lighting, personalized beam patterns, and advanced sensors are revolutionizing the driving experience. Beyond illumination, headlights now serve as intelligent tools for safety, design, and environmental responsibility, redefining what it means to drive in the modern era.' },
					// { img: "/assets/img/Main/video1.png", title: "7304A Product Introduction", date: '2024-12-16', described: 'Certainly!If Youare looking for reliable and new LED solutions,there are several key factors and trends to consider...' },
					// { img: "/assets/img/Main/video2.png", title: "7304A Product Introduction", date: '2024-12-16', described: 'Certainly!If Youare looking for reliable and new LED solutions,there are several key factors and trends to consider...' },

				],
				vlogData: [],
				// 当前页码
				currentPage: 1,
				// 每页显示的数据条数
				pageSize: 6,
				// 总数据条数
				totalData: 0,
				// currentPage: 1,  // 当前显示的页面
				// itemsPerPage: 6,  // 每页显示3张图片
				treeData: [],
				defaultProps: {
					children: 'children',
					label: 'name'
				},
				dialogVisible: false,
				currentContent: '',
				isFullscreen: false,
				currentVideo: '',

				showModal: false,
				popTitle: '',
				popDate: '',
				popSum: '',

				modalTop: 50,
				modalLeft: 200,
				isDragging: false,
				startX: 0,
				startY: 0,
				startModalX: 0,
				startModalY: 0
			};
		},
		computed: {
			// slidesgroup() {
			// 	return Math.ceil(this.slides.length / 6);
			// },
			// displayedSlides() {
			// 	const start = (this.currentPage - 1) * this.itemsPerPage;
			// 	const end = start + this.itemsPerPage;
			// 	return this.slides.slice(start, end);
			// },
			paginatedData() {
				const start = (this.currentPage - 1) * this.pageSize;
				const end = this.currentPage * this.pageSize;
				return this.slides.slice(start, end);
			},
		},

		created() {
			this.getTypeList();
			this.getVlogData();
		},
		methods: {
			navigateTo(id) {

				if (window.innerWidth * 0.60 > 1060) {
					this.modalLeft = (window.innerWidth - 1060) / 2;
				}
				else {
					this.modalLeft = window.innerWidth * 0.40 / 2;
				}
				this.modalTop = 0;
				this.currentContent = '';
				this.popDate = '';
				this.popSum = '';
				this.popTitle = '';

				// this.$router.push(`${this.$route.path}/` + id);
				try {
					getVlogData({ strWhere: ' and a.ID=' + id }).then((res) => {
						if (res.data.length == 0) {
							this.currentContent = '';
							this.slides = [];
						}
						else {
							this.popDate = res.data[0].date.replace('T', ' ');
							this.popSum = res.data[0].summary;
							this.popTitle = res.data[0].title
							this.currentContent = res.data[0].content;
							// this.currentContent = this.content.replace(/<p>\s*<span\s+style="color:\s*black;">/gi, `<p><span style="color: white;">`);

						}

					});

				} catch (error) {
					console.log(error);
				}
				this.showModal = true;
			},
			// 当前页码改变时的处理函数
			handleCurrentChange(page) {
				this.currentPage = page;
			},
			closeShowModal() {
				this.showModal = false;
				this.currentContent = '';
				this.popDate = '';
				this.popSum = '';
				this.popTitle = '';
			},
			openNewWin(aaa) {
				try {
					const newWindow = window.open(aaa, '_blank');
					if (!newWindow) {
						alert('您的浏览器可能阻止了弹出窗口。请允许并重试。');
					}
				} catch (error) {
					console.error('无法打开新标签页:', error);
				}
			},
			handleNodeClick(data, node, tree) {
				console.log('Node clicked:', data, node, tree);

				this.slides = [];
				if (node.childNodes.length > 0) {
					this.getVlogData('');
				}
				else {
					this.getVlogData(' and a.typeID=' + node.data.id);
				}

				// 在这里处理节点点击的逻辑
			},
			//获取数据
			getTypeList() {
				getVlogTypeNum().then(res => {
					if (res.data.length == 0) {
						// console.log(this.treeData)
					}
					else {
						this.treeData = res.data;
					}

					if (this.treeData.length > 0) {
						this.$nextTick(() => {
							this.$refs.treeleft.setCurrentKey(this.treeData[0].id);
						});
					}
				})
			},
			getVlogData(strWhere) {

				this.currentPage = 1;
				const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
				const videoExtensions = ['mp4', 'webm', 'ogg', 'avi', 'mkv', ''];
				this.vlogData = [];
				getVlogNoContent({ strWhere: strWhere }).then(res => {
					this.totalData = res.data.length
					if (res.data.length == 0) {
						// console.log(this.treeData)
					}
					else {
						res.data.forEach(element => {
							// const extension = element.url == null ? element.url.split('.').pop().toLowerCase() : '';
							const extension = element.url == null ? '' : element.url.split('.').pop().toLowerCase();
							let isImage = true
							let isVideo = false

							if (imageExtensions.includes(extension)) {
								isImage = true;
								isVideo = false;
							}
							if (videoExtensions.includes(extension)) {
								isImage = false;
								isVideo = true;
							}
							const date = new Date(element.date)
							const year = date.getFullYear()
							const month = (date.getMonth() + 1).toString().padStart(2, '0')
							const day = date.getDate().toString().padStart(2, '0')
							var item = {
								id: element.id, typeID: element.typeID, content: element.content
								, title: element.title, summary: element.summary
								, date: `${year}-${month}-${day}`
								, url: '../../../assets/img/Vlog/' + element.url
								, isImage: isImage, isVideo: isVideo
							}
							this.slides.push(item);
						})
						// this.slides = res.data;
						// this.slides.forEach(element => {
						// 	element.url = '../../../assets/img/Vlog/' + element.url
						// 	console.log(element)
						// });
					}
					// console.log('111', this.slides)
				})
			},
			showContent(id) {
				getVlogData({ strWhere: ' and a.ID=' + id }).then(res => {
					this.currentContent = res.data[0].content
				})
				this.dialogVisible = true;

			},

			searchData(value) {
				if (this.vlogData.length == 0) {
					this.vlogData = this.slides
				}
				if (value.length == 0) {
					this.slides = this.vlogData
					this.vlogData = []
				}
				else {
					this.slides = this.vlogData.filter(product => product.title.toLowerCase().includes(value.toLowerCase()) || product.summary.toLowerCase().includes(value.toLowerCase()));
				}

				this.currentPage = 1;
				this.totalData = this.slides.length
			},

			toggleFullscreen(videoUrl) {
				this.currentVideo = videoUrl
				this.isFullscreen = true;
			},

			startDrag(e) {
				// // 只有点击头部区域才能拖动
				// if (e.target.closest('.modal-header')) {
				// 	this.isDragging = true
				// 	this.startX = e.clientX
				// 	this.startY = e.clientY
				// 	this.startModalX = this.modalLeft
				// 	this.startModalY = this.modalTop

				// 	document.addEventListener('mousemove', this.onDrag)
				// 	document.addEventListener('mouseup', this.stopDrag)
				// }
				this.isDragging = true
				this.startX = e.clientX
				this.startY = e.clientY
				this.startModalX = this.modalLeft
				this.startModalY = this.modalTop

				document.addEventListener('mousemove', this.onDrag)
				document.addEventListener('mouseup', this.stopDrag)
			},
			onDrag(e) {
				if (this.isDragging) {
					const dx = e.clientX - this.startX
					const dy = e.clientY - this.startY
					this.modalLeft = this.startModalX + dx
					this.modalTop = this.startModalY + dy
				}
			},
			stopDrag() {
				this.isDragging = false
				document.removeEventListener('mousemove', this.onDrag)
				document.removeEventListener('mouseup', this.stopDrag)
			},
		},
		beforeDestroy() {
			// 组件销毁时移除事件监听
			document.removeEventListener('mousemove', this.onDrag)
			document.removeEventListener('mouseup', this.stopDrag)
		},
	}
</script>

<style scoped>
	.tree-line {
		background-color: transparent;
		color: #D3D3D2;
	}

	::v-deep .el-tree-node.is-current>.el-tree-node__content {
		background: #FCB42E !important;
		color: black;
	}

	:deep(.photo-group) {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
	}

	:deep(.photo-container) {
		text-align: center;
		position: relative;
		width: 10rem;
		height: 9rem;
		cursor: pointer;
		display: flex;
		justify-content: center;
	}

	@media (max-width: 576px) {
		:deep(.photo-container) {
			width: 10rem;
		}
	}

	:deep(.photo-title) {
		margin-top: 7rem;
		font-size: 14px;
		color: #9E9E9E;
	}

	@media (max-width: 1200px) {
		:deep(.photo-container:not(:last-child)::after) {
			width: 0px;
		}
	}


	:deep(.photo-container img) {
		position: absolute;
		top: 0;
		width: 6.5rem;
		object-fit: contain;
		transition: opacity 0.3s ease-in-out;
		/* 平滑的切换效果 */
	}

	:deep(.carousel) {
		position: relative;
		width: 100%;
		height: 300px;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	:deep(.carousel-wrapper) {
		position: relative;
		width: 360px;
		height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		perspective: 1000px;
	}

	:deep(.carousel-item) {
		position: absolute;
		width: 360px;
		height: 300px;
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
		transition: transform 0.5s ease, z-index 0.5s ease;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
	}

	:deep(.carousel-item img) {
		width: 100%;
		height: auto;
		border-radius: 10px;
	}

	:deep(.carousel-item p) {
		position: absolute;
		bottom: 10px;
		font-size: 14px;
		color: #333;
	}

	:deep(.control) {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		font-size: 20px;
		background: rgba(0, 0, 0, 0.5);
		color: white;
		border: none;
		cursor: pointer;
		padding: 0px 12px;
		border-radius: 50%;
		z-index: 20;
	}

	:deep(.control.left) {
		left: 10px;
	}

	:deep(.control.right) {
		right: 10px;
	}

	:deep(.control:hover) {
		background: rgba(0, 0, 0, 0.8);
	}

	:deep(.card-title) {
		margin-bottom: 0.2rem;
	}

	:deep(.card-body) {
		color: #9E9E9E
	}

	:deep(.card-text) {
		font-size: 14px;
	}

	@media (max-width: 768px) {
		:deep(.carousel-wrapper) {
			width: 90%;
		}

		:deep(.carousel-item) {
			max-width: 300px;
		}
	}

	:deep(.container .col-md-8) {
		display: ruby;
		text-align: right;
		position: fixed;
		bottom: 0px;
		right: 0px;
	}

	@media (max-width: 768px) {
		:deep(.container .col-md-8) {
			width: 100%;
			position: relative;
			text-align: left;
			margin-top: 12px;
		}
	}

	@media (max-width: 480px) {
		:deep(.carousel-wrapper) {
			width: 100%;
		}

		:deep(.control) {
			font-size: 15px;
			padding: 0px 9px;
		}
	}

	.popup {
		position: fixed;
		top: 53%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: #424242;
		/* border: 1px solid #ccc; */
		border-bottom: 10px solid #262626;
		border-left: 10px solid #262626;
		border-right: 10px solid #262626;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		z-index: 1000;
	}

	:deep(.ql-align-center) {
		text-align: center !important;
		/* font-weight: bold; */
		font-size: 18px;
		margin-bottom: 15px;
		margin-top: 10px;
	}

	.trigger-div {
		padding: 20px;
		background: #424242;
		/* border: 1px solid #ccc; */
		cursor: pointer;
		text-align: center;
		margin: 20px;
	}

	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
	}

	.draggable-modal {
		position: absolute;
		background-color: #424242;
		border-radius: 8px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
		width: 60%;
		height: 100%;
		max-width: 1060px;
		min-width: 300px;
		min-height: 200px;
		cursor: move;
	}

	.modal-header {
		padding: 5px;
		background-color: #262626;
		color: white;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		cursor: move;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: none;
	}

	.close-btn {
		background: none;
		border: none;
		color: white;
		font-size: 20px;
		cursor: pointer;
		padding: 0;
		width: 30px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.close-btn:hover {
		background-color: rgba(255, 255, 255, 0.2);
		border-radius: 50%;
	}

	.modal-content {
		padding-right: 20px;
		padding-left: 20px;
		padding-bottom: 20px;
		height: calc(100% - 55px);
		border: none;
		overflow-x: auto;
		/* 隐藏水平溢出 */
		overflow-y: auto;
		/* 强制垂直滚动 */
		background-color: #424242;
	}
</style>